var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        value: _vm.isOpen,
        "offset-y": "",
        "close-on-content-click": false,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-badge",
                {
                  attrs: {
                    overlap: "",
                    value: _vm.activeFilters.length > 0,
                    content: _vm.activeFilters.length,
                  },
                },
                [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        staticClass: "text-capitalize",
                        on: {
                          click: function ($event) {
                            _vm.isOpen = true
                          },
                        },
                      },
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-filter-outline"),
                      ]),
                      _vm._v(" Filters "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-card",
        { staticClass: "py-4 fill", attrs: { width: "350" } },
        _vm._l(_vm.filters, function (filter) {
          return _c(
            "div",
            { key: filter.key },
            [
              _c(
                "v-list-item",
                [
                  filter.type == "select"
                    ? _c("v-autocomplete", {
                        staticClass: "pl-3",
                        attrs: {
                          items: filter.options,
                          label: filter.name,
                          "menu-props": { maxHeight: 225 },
                          "auto-select-first": "",
                          "background-color": "input",
                          clearable: "",
                          dense: "",
                          "hide-details": "",
                          "item-text": "description",
                          "item-value": "id",
                          outlined: "",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.handleInputValue(filter)
                          },
                          "click:clear": function ($event) {
                            return _vm.removeFilter(filter.key)
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "item",
                              fn: function (data) {
                                return [
                                  _c(
                                    "v-list-item-content",
                                    { staticStyle: { "max-width": "275px" } },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "wrap-text subtitle-2" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(data.item.description) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.params[`${filter.key}`],
                          callback: function ($$v) {
                            _vm.$set(_vm.params, `${filter.key}`, $$v)
                          },
                          expression: "params[`${filter.key}`]",
                        },
                      })
                    : _vm._e(),
                  filter.type === "boolean"
                    ? _c("v-checkbox", {
                        staticClass: "pl-3 pt-0 my-0",
                        attrs: { label: filter.name, "hide-details": "" },
                        on: {
                          change: function ($event) {
                            return _vm.handleInputValue(filter)
                          },
                        },
                        model: {
                          value: _vm.params[`${filter.key}`],
                          callback: function ($$v) {
                            _vm.$set(_vm.params, `${filter.key}`, $$v)
                          },
                          expression: "params[`${filter.key}`]",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }